

const ReviewsData = [
    {
        comment: 'We AA booked Booth for our 10-Year High School Reunion and it was such a hit! ',
        name: 'Alonna Williams'
    },
    {
        comment: 'My family and friends enjoyed the photo booth! at my wedding reception lots of fun! Thumbs up! To AA Photo Booth!',
        name: 'Kim Howard'
    },
    {
        comment: 'Great experience, photos/videos were great.  Would definitely do this again at our next party.',
        name: 'Kalyan Latchamsetty'
    },
    {
        comment: 'Absolutely amazing experience! Customers had an absolute blast at our event with the 360 booth. Definitely drove more traffic into the store. ',
        name: 'Allie Dristle'
    },
    {
        comment: 'Such a great experience with AA Photo Booth!  The set up, back drop, and execution were flawless. The price was great as well.',
        name: 'Leslie Chiappetti'
    },
    {
        comment: 'Everyone loved the photo booth! Our photos turned out great. Good communication.',
        name: 'Kate Russo'
    }
];
export default ReviewsData